import React, { useEffect, useState, createContext, useContext } from 'react';
// Mock data for demonstration
const mockUsers = [{
  id: 1,
  name: 'Admin User',
  email: 'admin@example.com',
  password: 'admin123',
  isAdmin: true
}, {
  id: 2,
  name: 'Brandi',
  email: 'brandi@example.com',
  password: 'password',
  isAdmin: false
}, {
  id: 3,
  name: 'Brian',
  email: 'brian@example.com',
  password: 'password',
  isAdmin: false
}, {
  id: 4,
  name: 'Kaitlynn',
  email: 'kaitlynn@example.com',
  password: 'password',
  isAdmin: false
}, {
  id: 5,
  name: 'Sarah',
  email: 'sarah@example.com',
  password: 'password',
  isAdmin: false
}, {
  id: 6,
  name: 'Michelle',
  email: 'michelle@example.com',
  password: 'password',
  isAdmin: false
}];
type User = {
  id: number;
  name: string;
  email: string;
  isAdmin: boolean;
};
type UserContextType = {
  user: User | null;
  users: User[];
  login: (email: string, password: string) => boolean;
  logout: () => void;
  addUser: (user: Omit<User, 'id'> & {
    password: string;
  }) => void;
  deleteUser: (id: number) => void;
};
const UserContext = createContext<UserContextType | undefined>(undefined);
export const UserProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [user, setUser] = useState<User | null>(null);
  const [users, setUsers] = useState<User[]>([]);
  useEffect(() => {
    // Load users from localStorage or use mock data
    const savedUsers = localStorage.getItem('apnUsers');
    if (savedUsers) {
      setUsers(JSON.parse(savedUsers));
    } else {
      setUsers(mockUsers);
      localStorage.setItem('apnUsers', JSON.stringify(mockUsers));
    }
    // Check for logged in user
    const loggedInUser = localStorage.getItem('apnCurrentUser');
    if (loggedInUser) {
      setUser(JSON.parse(loggedInUser));
    }
  }, []);
  const login = (email: string, password: string): boolean => {
    const allUsers = [...users];
    const foundUser = allUsers.find(u => u.email === email && password === password);
    if (foundUser) {
      const {
        password,
        ...userWithoutPassword
      } = foundUser as any;
      setUser(userWithoutPassword);
      localStorage.setItem('apnCurrentUser', JSON.stringify(userWithoutPassword));
      return true;
    }
    return false;
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem('apnCurrentUser');
  };
  const addUser = (newUser: Omit<User, 'id'> & {
    password: string;
  }) => {
    const updatedUsers = [...users, {
      ...newUser,
      id: users.length + 1
    }];
    setUsers(updatedUsers);
    localStorage.setItem('apnUsers', JSON.stringify(updatedUsers));
  };
  const deleteUser = (id: number) => {
    const updatedUsers = users.filter(user => user.id !== id);
    setUsers(updatedUsers);
    localStorage.setItem('apnUsers', JSON.stringify(updatedUsers));
  };
  return <UserContext.Provider value={{
    user,
    users,
    login,
    logout,
    addUser,
    deleteUser
  }} data-id="element-459">
      {children}
    </UserContext.Provider>;
};
export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};